export default "__VITE_ASSET__BVL6$h8I__"